import { DateFormats, IClinician } from "intake_shared/src/types";
import moment from "../../../../utils/app_moment";

interface BookingPauseDetailsProps {
    clinician: IClinician;
}

export default function BookingPauseDetails({
    clinician,
}: BookingPauseDetailsProps) {
    return (
        <div>
            <div>
                <strong>Reason:</strong>{" "}
                {clinician.booking_pause_reason ?? "Not recorded"}
            </div>
            <div>
                <strong>Paused by:</strong>{" "}
                {clinician.booking_paused_by ?? "Not recorded"}
            </div>
            <div>
                <strong>Paused on:</strong>{" "}
                {clinician.booking_paused_at
                    ? moment(clinician.booking_paused_at).format(
                          DateFormats.DAY_YEAR_HOUR_MIN_FORMAT
                      )
                    : "Not recorded"}
            </div>
        </div>
    );
}
